import { PropsWithChildren } from "react";
import { classNames } from "./Utils/classNames.ts";

export function Card({
  children,
  classes,
}: PropsWithChildren<{
  classes?: string;
}>) {
  return (
    <div
      className={classNames(
        "space-y-6 bg-white p-8 rounded-lg shadow-xl shadow-slate-200",
        classes,
      )}
    >
      {children}
    </div>
  );
}
